<template>
    <button v-bind:disabled=clicked title="Adds your communities underground pipe data if it was submitted." v-on:click='queryAssetData()'>Display Asset Data</button>
</template>

<script>
    import {loadModules} from "esri-loader";

    export default {
        name: "AssetDataButton",
        data: function(){
            return{
                clicked: false,
            }
        },
        methods: {
            addLayer: function (id) {
                let vue_this = this;
                let layer_names = {0: 'Water Main', 1: 'Sanitary Force Main', 2: 'Storm Gravity Main', 3: 'Storm Force Main', 4: 'Sanitary Gravity Main'};
                let layer_colors = {0: '#0070FF', 1: '#FFAA00', 2: '#38A800', 3: '#38A800', 4: '#FFAA00'};
                loadModules(["esri/layers/FeatureLayer"], {css: true})
                    .then(([FeatureLayer]) => {
                        let layers = Object.keys(layer_names);
                        layers.forEach(function (l) {

                            var popupAssets = {
                                "title": `${layer_names[l]}`,
                                "content": "Size: {Size} <br>Material: {Material} <br>Surface Type: ${Surface_Type}",
                            };

                            var lyr = new FeatureLayer({
                                portalItem: {
                                    id: id
                                },
                                layerId: l,
                                popupTemplate: popupAssets,
                                renderer: {
                                    type: 'simple',
                                    symbol: {
                                        color: layer_colors[l],
                                        type: "simple-line",
                                        style: "solid",
                                        width: "4px"
                                    },
                                    label: layer_names[l]
                                },
                            });
                            vue_this.$parent.map.add(lyr, 4);
                            vue_this.$parent.legend.layerInfos.push({
                                layer: lyr,
                                title: layer_names[l]
                            })

                            var Query = lyr.createQuery();
                            lyr.queryFeatures(Query).then(function (response) {
                                let Geometries = response.features.map(function (feature) {
                                    return feature.geometry;
                                });
                                vue_this.$parent.view.goTo(Geometries);
                            });
                        })
                    });
            },
            queryAssetData: function () {
                let vue_this = this;
                this.clicked = true;
                loadModules(["esri/portal/Portal",
                    "esri/portal/PortalQueryParams"], {css: true})
                    .then(([Portal, PortalQueryParams]) => {
                        var portal = new Portal();
                        portal.load().then(function () {
                            // Create query parameters for the portal search
                            var queryParams = new PortalQueryParams({
                                query: "owner:" + portal.user.username,
                                sortField: "numViews",
                                sortOrder: "desc",
                                num: 20
                            });

                            // Query the items based on the queryParams created from portal above
                            portal.queryItems(queryParams).then(function (r) {
                                r.results.forEach(function (i) {
                                    if (i.title === 'Asset Management Community Data') {
                                        vue_this.addLayer(i.id);
                                    }
                                })
                            });
                        });
                    })
            }
        }
    }
</script>

<style scoped>
    button{
        max-width: 60px;
        font-size: small;
        background: white;
        padding: 3px 10px;
        border-width: 1px;
        border-style: solid;
        border-color: #d2cece;
    }


</style>